import React from "react";

const EnergoTabElem = ({item, clickHandler}) => {

    return (
        <div
            onClick={() => item.count > 0? clickHandler(item.id): null}
            style={{
                flexGrow: 1,
                display: "flex",
                height: "100%",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
            }}
            className={`${item.selected? "bg-energo ":""} ${item.count === 0? "disabled ": ""}`}
        >
            {item.name} {item.count > 1? "("+item.count+")": ""}
        </div>
    )
}
export default EnergoTabElem;